import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import type { KeyboardEventHandler } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useUserContext } from "@dexteel/mesf-core";
import { CraftsFilter } from "./craftsFilter";
import { EndFilter } from "./endFilter";
import { useSearchParamsToReducer } from "./hooks/useSearchParamsToReducer";
import { SearchFilter } from "./SearchFilter";
import { StartFilter } from "./startFilter";
import { StatusFilter } from "./statusFilter";
import { TypesFilter } from "./typesFilter";
import { useWorkOrdersContext } from "../context/workOrdersContext";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
	searchData: Function;
};

export const Filters = ({ onKeyDown, searchData }: Props) => {
	useSearchParamsToReducer({ searchData });
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const {
		state: { defaultAreaId },
	} = useUserContext();
	const {
		actions: { setFirstTime },
	} = useWorkOrdersContext();

	const resetFilter = () => {
		setFirstTime(true);
		setSearchParams(new URLSearchParams(), { replace: true });
		setTimeout(() => {
			navigate(`/work-orders/${defaultAreaId}`, { replace: true });
		}, 50);
	};

	return (
		<Grid container item md={12} xs={12} alignItems="flex-end" spacing={1}>
			<Grid item lg={2} md={6} xs={6}>
				<StartFilter />
			</Grid>
			<Grid item lg={2} md={6} xs={6}>
				<EndFilter />
			</Grid>
			<Grid item lg={2} md={6} xs={6}>
				<SearchFilter onKeyDown={onKeyDown} />
			</Grid>
			<Grid item lg={1} md={6} xs={6}>
				<StatusFilter />
			</Grid>
			<Grid item lg={2} md={6} xs={6}>
				<CraftsFilter />
			</Grid>
			<Grid item lg={2} md={6} xs={6}>
				<TypesFilter />
			</Grid>
			<Grid item lg={1} md={6} xs={6}>
				<Box style={{ marginTop: "8px", marginBottom: "4px" }}>
					<Button
						fullWidth
						variant="contained"
						color="default"
						onClick={resetFilter}
						style={{ height: "40px" }}
					>
						RESET
					</Button>
				</Box>
			</Grid>
		</Grid>
	);
};
